// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2323fad7","41":"be30b3a6","90":"6c53e0f4","428":"b27356a8","659":"e5f15958","735":"b1a8a649","838":"a34d9849","920":"696e7f36"}[chunkId] + ".chunk.js";
};